import { render, staticRenderFns } from "./PatientDoctorDataTable.vue?vue&type=template&id=43c8ceca&scoped=true"
import script from "./PatientDoctorDataTable.vue?vue&type=script&lang=js"
export * from "./PatientDoctorDataTable.vue?vue&type=script&lang=js"
import style0 from "./PatientDoctorDataTable.vue?vue&type=style&index=0&id=43c8ceca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43c8ceca",
  null
  
)

export default component.exports